export const APP_VERSION = process.env.VUE_APP_VERSION;

export const ROLES = {
  admin: "Admin",
  md: "Endo",
  rn: "Nurse",
  manager: "Manager",
  viewer: "Viewer"
};

export const PARTICIPANT_DETAILS_TITLES = {
  sex: {
    title: "Sex",
    type: "select"
  },
  height: {
    title: "Height (cm)",
    type: "number"
  },
  weight: {
    title: "Weight (kg)",
    type: "number"
  },
  dateOfBirth: {
    title: "Date of birth",
    type: "date"
  },
  dateOfDiagnosis: {
    title: "Date of diagnosis",
    type: "date"
  },
  studyStartDate: {
    title: "Study start date",
    type: "date-picker"
  },
  admissionVisitDate: {
    title: "Admission visit date",
    type: "date-picker"
  },
  studyEndDate: {
    title: "Study end date",
    type: "date-picker"
  },
  studyEndVisitDate: {
    title: "End-of-study visit date",
    type: "date-picker"
  },
  personalSensorModel: {
    title: "Personal sensor model",
    type: "select"
  },
  personalSensorModelStartDate: {
    title: "Start date of personal sensor model",
    type: "date-picker"
  },
  hba1c: {
    title: "HbA1c",
    type: "text"
  }
};

export const SEX_ITEMS = [
  {
    value: "male",
    text: "Male"
  },
  {
    value: "female",
    text: "Female"
  },
  {
    value: "other",
    text: "Other"
  }
];

export const SENSOR_MODELS_ITEMS = [
  {
    value: "n/a",
    text: "N/A"
  },
  {
    value: "freestyle-libre",
    text: "Freestyle Libre"
  },
  {
    value: "dexcom-g6",
    text: "Dexcom G6"
  },
  {
    value: "dexcom-g5",
    text: "Dexcom G5"
  },
  {
    value: "medtronic-guardian",
    text: "Medtronic Guardian"
  },
  {
    value: "medtronic-enlite",
    text: "Medtronic Enlite"
  },
  {
    value: "other",
    text: "Other (add note)"
  }
];

export const DAYS_ARRAY = [
  {
    value: 1,
    text: "Monday"
  },
  {
    value: 2,
    text: "Tuesday"
  },
  {
    value: 3,
    text: "Wednesday"
  },
  {
    value: 4,
    text: "Thursday"
  },
  {
    value: 5,
    text: "Friday"
  },
  {
    value: 6,
    text: "Saturday"
  },
  {
    value: 7,
    text: "Sunday"
  }
];

export const parametersKeyToName = {
  activeInsulinTime: "Active insulin time",
  basaDose: "Basal dose",
  exerRatios: "Exercise ratios",
  fatRatios: "Fat ratios",
  incrBasal: "Basal pen increments",
  incrBolus: "Bolus pen increments",
  insuCarbRatio: "Insulin to carb ratios",
  insuSensFactor: "Insulin sensitivity factor",
  isAM: "Carb counting",
  targGlucose: "Target glucose",
  id: "ID"
};

// Example: x_2020_01_01 returns 2020-01-01
export const decodeGraphDataKey = val => {
  return val
    .replace("x_", "")
    .replace("_", "-")
    .replace("_", "-");
};
// Example: 2020-01-01 returns x_2020_01_01
export const encodeGraphDataKey = val => {
  return `x_${val}`.replace("-", "_").replace("-", "_");
};

export const RULES = {
  required: value => !!value || "Required",
  counter: value => value.length <= 20 || "Max 20 characters",
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || "Invalid Email";
  },
  decimal: value =>
    (!isNaN(parseFloat(value)) && isFinite(value)) || "Value must be decimal"
};
